import { Popover } from '@magnetic/popover';
import React, { isValidElement } from 'react';
import { SelectableTag } from '../selectable/index.js';
import '@magnetic/theme';
import { SelectableOverflow } from './selectable-overflow.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const BasicOverflow = /* @__PURE__ */ __name(({
  hidden,
  overflowClassName,
  size = "md"
}) => /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Popover, {
  className: overflowClassName,
  title: hidden.map((current) => isValidElement(current) && current.props.children).join(", ")
}, /* @__PURE__ */ React.createElement(SelectableTag, {
  className: "mds-tag-overflow-source",
  size
}, `+${hidden.length}`))), "BasicOverflow");
const OverflowDropdown = /* @__PURE__ */ __name(({
  hidden,
  overflowClassName,
  selectable,
  size
}) => {
  if (hidden.length > 0) {
    return selectable ? /* @__PURE__ */ React.createElement(SelectableOverflow, {
      hidden,
      size
    }) : /* @__PURE__ */ React.createElement(BasicOverflow, {
      hidden,
      overflowClassName,
      size
    });
  }
  return null;
}, "OverflowDropdown");

export { OverflowDropdown };
//# sourceMappingURL=overflow-dropdown.js.map
